<template>
    <div class="hero__content">
        <!--        <video v-if="home_hero_is_video"-->
        <!--               class="hero__deco" autoplay muted loop playsinline :poster="home_hero_mobile_image" preload="auto">-->
        <!--            <source :src="home_hero_mobile_video" type="video/mp4">-->
        <!--        </video>-->
        <!--        <img v-else class="hero__deco" :src="home_hero_mobile_image" :alt="home_hero_alt">-->
        <Flicking :plugins="plugins" class="hero__deco hero__deco--carousel" ref="flicking"
                  :options="{defaultIndex: carouselStart, align: 'center', panelsPerView:1, circular: true, moveType: ['strict', { count: 1 }]}">
            <!--            <video v-if="home_hero_is_video"-->
            <!--                   class="hero__deco hero__deco--video" autoplay muted loop playsinline-->
            <!--                   :poster="home_hero_desktop_image" preload="auto">-->
            <!--                <source :src="home_hero_desktop_video" type="video/mp4">-->
            <!--            </video>-->
            <div v-for="(slide, slideKey) in home_hero_carousel_mobile_images" class="panel">
                <a href="#" @click="nextStep()">
                    <img :src="slide" :alt="home_hero_alt">
                </a>
            </div>
            <template v-if="carousel_arrow_v2 === 'true'">
                  <span slot="viewport" class="flicking-arrow-v2  flicking-arrow-v2-prev flicking-arrow-prev">
                    <svg width="49" height="49" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><circle fill="#000" opacity=".30076" style="mix-blend-mode:multiply" cx="24.5" cy="24.5" r="24.5"/><path d="M28 12 15 25l13 13" stroke="#FFF" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></g></svg>
                </span>
                <span slot="viewport" class="flicking-arrow-v2  flicking-arrow-v2-next flicking-arrow-next" >
                    <svg width="49" height="49" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><circle fill="#000" opacity=".30076" style="mix-blend-mode:multiply" transform="matrix(-1 0 0 1 49 0)" cx="24.5" cy="24.5" r="24.5"/><path d="m20 12 13 13-13 13" stroke="#FFF" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></g></svg>
                </span>

            </template>
            <template v-else-if="carousel_arrow_v3 === 'true'">
                  <span slot="viewport" class="flicking-arrow-v2  flicking-arrow-v2-prev narrow-box flicking-arrow-prev">
                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36"><g fill="none" fill-rule="evenodd"><ellipse cx="17.888" cy="18" fill="#FFF" rx="17.888" ry="18"/><path fill="#FA5528" fill-rule="nonzero" stroke="#FA5528" stroke-width=".5" d="M13.193 11.217a.733.733 0 0 1 1.042 0 .727.727 0 0 1 0 1.025L8.954 17.49H26.38c.406 0 .74.32.74.724a.74.74 0 0 1-.74.735H8.954l5.28 5.239a.74.74 0 0 1 0 1.035.733.733 0 0 1-1.04 0l-6.532-6.49a.727.727 0 0 1 0-1.025l6.531-6.49Z"/></g></svg>
                </span>
                <span slot="viewport" class="flicking-arrow-v2  flicking-arrow-v2-next narrow-box flicking-arrow-next" >
                    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="36"><g fill="none" fill-rule="evenodd" transform="translate(.676)"><ellipse cx="17.888" cy="18" fill="#FFF" rx="17.888" ry="18"/><path fill="#FA5528" fill-rule="nonzero" stroke="#FA5528" stroke-width=".5" d="M20.702 11.217a.733.733 0 0 0-1.042 0 .727.727 0 0 0 0 1.025l5.281 5.248H7.515c-.406 0-.74.32-.74.724a.74.74 0 0 0 .74.735h17.426l-5.28 5.239a.74.74 0 0 0 0 1.035c.29.29.75.29 1.04 0l6.532-6.49a.727.727 0 0 0 0-1.025l-6.531-6.49Z"/></g></svg>
                </span>
            </template>
            <template v-else>
                <span slot="viewport" class="flicking-arrow flicking-arrow-prev is-circle">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10.378" height="16"><path fill="none" fill-rule="evenodd" stroke="#FA5528" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m9.377 1-7.99 6.21a1 1 0 0 0 0 1.58L9.376 15h0"/></svg>
                </span>
                <span slot="viewport" class="flicking-arrow flicking-arrow-next is-circle">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10.378" height="16"><path fill="none" fill-rule="evenodd" stroke="#FA5528" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 7.991 6.21a1 1 0 0 1 0 1.58L1 15h0"/></svg>
                </span>
            </template>
        </Flicking>
        <slot></slot>
    </div>
</template>

<script>
import image_mixin from "../mixins/image_mixin";
import travel_step_mixin from "../../../components/form/steps/travel_step_mixin";

import {Flicking} from "@egjs/vue-flicking";
import "@egjs/vue-flicking/dist/flicking.css";

import {Arrow, AutoPlay} from "@egjs/flicking-plugins";
import "@egjs/flicking-plugins/dist/arrow.css";

export default {
    mixins:[
        image_mixin,
        travel_step_mixin
    ],
    components: {
        Flicking
    },
    data() {
        return {
            plugins: [
                new Arrow({
                    parentEl: document.querySelector('.hero__content')
                }),
                new AutoPlay({ duration: 5000, direction: "NEXT", stopOnHover: false })
            ],
            carouselStart:0,
        }
    },
    created() {
        this.carouselStart = _.get(queryString.parse(location.search), 'carousel', 0);
    }
}
</script>

<style scoped>

</style>
